import { useTranslation } from 'react-i18next';

import { Button } from 'react-bootstrap';
import Price from 'components/Price';
import Disclaimer from 'components/Price/Disclaimer';

import slugify from 'utils/slugify';

export const GradeCard = ({ gradeData, onSelect, onDetails }) => {
    const { t } = useTranslation();
    const { grade, model, body, engine, leasing, eic } = gradeData;

    const gradeId = grade?.id;
    const gradeName = grade?.name || '';
    const gradeImg = grade?.thumb;
    const bodyName = body?.name || '';
    const engineType = engine?.type || '';

    const badge = ['hybrid', 'electric'].filter(item => engineType.toLowerCase().includes(item))[0];
    const priceFrom = leasing?.period?.[0]?.mileage?.[0]?.price;

    const gradeToken = `grade_features_${slugify(model?.name, '_')}_${slugify(grade?.code, '_')}`;

    return (
        <div className="c-grade">
            <figure className="c-grade__img">
                <img src={gradeImg} alt={gradeName} />
            </figure>
            <div className="c-grade__body">
                <span className="c-badge-list">
                    <span className={`c-badge c-badge--${badge || 'default'}`}>{engineType}</span>
                </span>
                <h3 className="c-grade__title">{gradeName}</h3>
                <p className="c-grade__price">
                    <strong className="c-price c-price--new">
                        <span className="c-price__title">
                            {t('monthly_price')} <Price price={priceFrom} />
                        </span>
                        <Disclaimer />
                    </strong>
                </p>
                <div className="c-info__list">
                    {t(gradeToken)}
                </div>
                <p className="c-info__btn">
                    <Button variant="link" onClick={() => onDetails(eic, 'equipment')}>
                        {t('view_more_btn')}
                    </Button>
                </p>
            </div>
            <div className="c-grade__footer">
                <p className="c-grade__tech">{bodyName}</p>
                <p className="c-grade__btnline">
                    <Button variant="secondary" onClick={() => onSelect(gradeId)}>
                        {t('grade_select_button')}
                    </Button>
                </p>
            </div>
        </div>
    );
};
